import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/add-nested-product-category-controller';
import { NestedProductCategoryForm } from '../components/nested-product-categories-form';

export const AddNestedProductCategoryRoute = () => {
    const {
        formData,
        onSubmit,
        onCancel,
        onChange,
        isAddNestedProductCategoryLoading,
        errors,
        onCheckChange,
        isUnlimited,
    } = useController();

    return (
        <OWContainer>
            <NestedProductCategoryForm
                formData={formData}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onChange={onChange}
                onCheckChange={onCheckChange}
                isUnlimited={isUnlimited}
                isSaveLoading={isAddNestedProductCategoryLoading}
                errors={errors}
            />
        </OWContainer>
    );
};
